// @flow
import React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import CreatableSelect from "react-select/creatable";
import AsyncCreatableSelect from 'react-select/async-creatable';
import styles from "./Select.styles.js";
import api from "utils/API";

type Props = {
  clases: any,
  className: any,
  label: String,
  icon: String,
  type: String,
  hints: Array<any>,
  fullWidth: boolean
};

type State = {
  value: any
};

class Select extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      value: ""
    };
  }

  static defaultProps = {
    fullWidth: false
  };

  handleChange = (newValue: any, actionMeta: any) => {
    if (this.props.onChange) {
      this.props.onChange(newValue, actionMeta);
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  handleInputChange = (newValue: string) => {
    // const inputValue = newValue.replace(/\W/g, "");
    this.setState({ newValue });
    return newValue;
  };

  loadOptions = (inputValue, callback) => {
    const url = this.props.fetchUrl.replace(":_text_:", inputValue);
    api.get(url).then(response => {
      if (!response.data || !response.data.list) {
        return;
      }

      const suggestsList = response.data.list.map(item => {
        return { label: item.name, value: item.uid };
      });
      callback(suggestsList);
    });
  };

  renderElement = passedProps => {
    const { classList, type, text, icon, fetchUrl, ...props } = passedProps;

    if (fetchUrl) {
    console.log(fetchUrl)
      return (
        <AsyncCreatableSelect
          {...props}
          classes={{
            root: classList.classes.inputRoot,
            input: classNames(classList.classes.input, classList.inputClass)
          }}
          onChange={this.handleChange}
          loadOptions={this.loadOptions}
          onInputChange={this.handleInputChange}
        />
      );
    } else {
      return (
        <CreatableSelect
          {...props}
          classes={{
            root: classList.classes.inputRoot,
            input: classNames(classList.classes.input, classList.inputClass)
          }}
          onChange={this.handleChange}
        />
      );
    }
  };

  render() {
    const {
      classes,
      label,
      className,
      isMulti,
      isCreatable,
      options,
      ...props
    } = this.props;
    const rootClass = className && className.root;
    const inputClass = (className && className.input) || className;

    return (
      <FormControl
        fullWidth={this.props.fullWidth}
        className={classNames(classes.root, rootClass)}
      >
        {this.props.label && <label className={classes.label}>{label}</label>}
        {this.renderElement({
          classList: { classes, inputClass },
          options,
          isMulti,
          isCreatable,
          ...props
        })}

        {this.props.hints &&
          this.props.hints.map((item, index) => {
            return (
              <div key={index} className={classes.hint}>
                {item}
              </div>
            );
          })}
      </FormControl>
    );
  }
}

const Component = withStyles(styles)(Select);
export { Component as Select };
export default Component;
